import React from "react";
import axios from "axios";
import { Disclosure } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import Footer from "./Footer";
import config from "../config.js";

export default function TicketRegistrationForm() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const [vorname, setVorname] = useState("");
  const [anrede, setAnrede] = useState("Frau");
  const [nachname, setNachname] = useState("");
  const [email, setEmail] = useState("");
  const [land, setLand] = useState("");
  const [str, setStr] = useState("");
  const [ort, setOrt] = useState("");
  const [plz, setPlz] = useState("");
  const [exhibitor, setExhibitor] = useState();
  const [eventName, setEventName] = useState();
  const [eventAdress, setEventAdress] = useState();
  const [eventDate, setEventDate] = useState();
  const [eventId, setEventId] = useState();
  const { id } = useParams();

  const [exhibitorId, setExhibitorId] = useState();
  const [exhibitorName, setExhibitorName] = useState();

  const getExhibitor = async () => {
    axios
      .get(config.apiUrl + "/exhibitor?id=" + id)
      .then(function (response) {
        setExhibitorName(response.data.exhibitor_name);
        setExhibitor(response.data);
        setExhibitorId(response.data.exhibitor_id);
        setEventName(response.data.event_name);
        setEventAdress(response.data.event_address);
        setEventDate(response.data.event_date);
        setEventId(response.data.event_id);
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  if (!exhibitor) {
    getExhibitor();
  }

  const addAnmeldung = async () => {
    setShow(false);

    const data = {
      anrede: anrede,
      vorname: vorname,
      nachname: nachname,
      email: email,
      land: land,
      str: str,
      ort: ort,
      plz: plz,
      event: eventId,
      exhibitor: exhibitorId,
      // TODO: event should be automatically added by backend, not frontend
    };
    console.log(data);
    if (
      data.nachname.length > 0 &&
      data.vorname.length > 0 &&
      data.email.length > 0
    ) {
      axios
        .post(config.apiUrl + "/customers", data)
        .then(function (response) {
          navigate("/success/" + id);
        })
        .catch(function (error) {
          setShow(true);
        });
    } else {
      setShow(true);
    }
  };

  return (
    <>
      {!exhibitor && (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      )}
      {exhibitor && (
        <div className="min-h-full">
          <div className="bg-primarycol-600 pb-32">
            <Disclosure
              as="nav"
              className="bg-primarycol-600 border-b border-primarycol-300 border-opacity-25 lg:border-none"
            >
              {({ open }) => (
                <>
                  <div className="max-w-2xl mx-auto px-2 sm:px-4 lg:px-8">
                    <div className=" h-16 flex items-center justify-between lg:border-b lg:border-primarycol-400 lg:border-opacity-25">
                      <div className="px-2 flex items-center lg:px-0">
                        <img
                          className="lg:block h-8 w-auto"
                          src={"../../Logo-Einzeilig-weiss.png"}
                          alt="Workflow"
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Disclosure>
            <header className="py-10">
              <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold text-white">Registrieren</h1>
              </div>
            </header>
          </div>

          <main className="-mt-32">
            <div className="max-w-2xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
              <div className="bg-white rounded-lg shadow px-5 py-6 sm:px-6">
                <div className="pt-8 space-y-6 sm:pt-1 sm:space-y-5">
                  <div>
                    <p className="mt-1 max-w-2xl text-base text-gray-500">
                      Sie wurden von <b>{exhibitorName}</b> zur Veranstaltung{" "}
                      <b>{eventName}</b> eingeladen. <br></br>
                      Sie erhalten Ihr kostenloses Ticket via E-Mail nach Ihrer
                      Registrierung von info@savoirvivre.de. Bitte überprüfen
                      Sie auch Ihren Spam-Ordner. <br></br>Danach können Sie
                      weitere Tickets bestellen.<br></br>Servicetelefon bei
                      Fragen: +49 171 1200786.
                    </p>
                    <div class="border text-sm border-gray-300 py-2 px-4 mt-8 text-center rounded-md max-w mx-auto">
                      {eventName}
                    </div>
                    <div
                      class="border text-sm border-gray-300 py-2 px-4 mt-4 text-center rounded-md max-w mx-auto"
                      dangerouslySetInnerHTML={{ __html: eventAdress }}
                    ></div>
                    <div
                      class="border text-sm border-gray-300 py-2 px-4 mt-3 text-center rounded-md max-w mx-auto"
                      dangerouslySetInnerHTML={{ __html: eventDate }}
                    ></div>
                  </div>
                  <div className="space-y-6 sm:space-y-5 pt-6">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Persönliche Informationen
                    </h3>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="anrede"
                        className="block text-base font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        Anrede
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <select
                          id="anrede"
                          name="anrede"
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                          defaultValue="Frau"
                          onChange={(e) => setAnrede(e.target.value)}
                        >
                          <option key="Frau" value="Frau">
                            Frau
                          </option>
                          <option key="Herr" value="Herr">
                            Herr
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="first-name"
                        className="block text-base font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        Vorname
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <input
                          required
                          type="text"
                          name="first-name"
                          id="first-name"
                          autoComplete="given-name"
                          onChange={(e) => setVorname(e.target.value)}
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="last-name"
                        className="block text-base font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        Nachname
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <input
                          required
                          type="text"
                          name="last-name"
                          id="last-name"
                          onChange={(e) => setNachname(e.target.value)}
                          autoComplete="family-name"
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                    </div>

                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="email"
                        className="block text-base font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        Email Adresse
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <input
                          required
                          id="email"
                          name="email"
                          onChange={(e) => setEmail(e.target.value)}
                          type="email"
                          autoComplete="email"
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                    </div>

                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="street-address"
                        className="block text-base font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        Straße, Nr.
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <input
                          type="text"
                          name="street-address"
                          onChange={(e) => setStr(e.target.value)}
                          id="street-address"
                          autoComplete="street-address"
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="postal-code"
                        className="block text-base font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        PLZ
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <input
                          type="text"
                          name="postal-code"
                          onChange={(e) => setPlz(e.target.value)}
                          id="postal-code"
                          minLength={2}
                          autoComplete="postal-code"
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="city"
                        className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        Ort
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <input
                          type="text"
                          name="city"
                          onChange={(e) => setOrt(e.target.value)}
                          id="city"
                          autoComplete="address-level2"
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label
                        htmlFor="last-name"
                        className="block text-base font-medium text-gray-700 sm:mt-px sm:pt-2"
                      >
                        Land
                      </label>
                      <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <input
                          type="text"
                          name="country"
                          onChange={(e) => setLand(e.target.value)}
                          id="country"
                          autoComplete="country-name"
                          className="max-w-lg block w-full shadow-sm focus:ring-primarycol-500 focus:border-primarycol-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                    </div>
                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"></div>
                    <div className="pt-5">
                      <div className="flex justify-end">
                        <button
                          type="submit"
                          onClick={addAnmeldung}
                          className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-primarycol-600 hover:bg-primarycol-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primarycol-500"
                        >
                          Registrieren
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer></Footer>
          </main>
        </div>
      )}
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                      />
                    </svg>
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">Fehler</p>
                    <p className="mt-1 text-sm text-gray-500">
                      Bitte füllen Sie alle Felder aus!
                    </p>
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                    <button
                      type="button"
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
      <style jsx>{`
        .spinner-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh; /* Adjust as necessary */
        }
        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(0, 0, 0, 0.1);
          border-top-color: #333;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
}
